<template>
    <div class="footer">
        <div class="image-container">
            <img class="image" src="../../../../public/img/logo/logo-repense-white.png" alt="">
            <img class="image" src="../../../../public/img/logo/logo-white.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .footer{
        height: 7vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(155,254,248);
        background: linear-gradient(100deg, rgba(155,254,248,1) 0%, rgba(61,240,229,1) 100%);

        .image-container{

            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .image{

                height: 18px;
                margin : auto 3%;
            }
        }
    }
</style>
